import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { environment } from "../../../environments/environment";
import { AuthService } from "../../auth/auth.service";
import { ActionButton } from "../action-button/action-button.model";
import * as i0 from "@angular/core";
import * as i1 from "../../core/environment.tokens";
import * as i2 from "@angular/common/http";
import * as i3 from "../../auth/auth.service";
export class DevControllerService {
    constructor(baseApiUrl, http, authService) {
        this.baseApiUrl = baseApiUrl;
        this.http = http;
        this.authService = authService;
        this.controls = new BehaviorSubject([]);
    }
    clear() {
        this.controls.next([
            new ActionButton({
                name: "Print User",
                action: () => console.log(this.authService.user),
            }),
        ]);
    }
    push(item) {
        if (!environment.production) {
            const items = this.controls.getValue();
            items.push(...item);
            this.controls.next(items);
        }
    }
}
DevControllerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DevControllerService_Factory() { return new DevControllerService(i0.ɵɵinject(i1.BASE_API_URL), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.AuthService)); }, token: DevControllerService, providedIn: "root" });
